import React, { useEffect, useState } from "react";

const CYCLE_MS = 5000;
const FADE_MS = 400;

export default function AnnouncementBar() {
  const [announcements, setAnnouncements] = useState([]);
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_HOST}/api/announcements/active`)
      .then((res) => (res.ok ? res.json() : []))
      .then(setAnnouncements)
      .catch((err) => console.error("Error fetching announcements:", err.message));
  }, []);

  useEffect(() => {
    if (announcements.length < 2) return;

    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % announcements.length);
        setVisible(true);
      }, FADE_MS);
    }, CYCLE_MS);

    return () => clearInterval(interval);
  }, [announcements]);

  if (announcements.length === 0) {
    return null;
  }

  return (
    <div className="bg-purple-950 text-white text-center text-sm py-1 px-4">
      <span
        style={{
          transition: `opacity ${FADE_MS}ms ease-in-out`,
          opacity: visible ? 1 : 0,
        }}
      >
        {announcements[index].message}
      </span>
    </div>
  );
}
